module.exports = __webpack_public_path__ + "static/img/mingming.f95d926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiazia/mingming.png
// module id = MaKD
// module chunks = 0